<template>
	<div class="incenters">
		<div>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px"
				:useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="proExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="Productexport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" @click="proDowload">导入模板下载</a>
		</div>
		<div class="TableWidth">
			<Commontable ref="ProviderRef" @onRowClick="onRowClick" colnum="7" :tableData="tableData"
				:headerData="headerData" height="100%" @handleSelectionChange="handleSelectionChange"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="850px" :title="`${from.ID?'编辑':'新增'}产品线NTS配额`" :dialogVisible="dialogVisibles"
			@cancel="cancel" @dialogOK="dialogOK">
			<div class="from-grid">
				<Commondropdownlist ref="proadd" v-for="(item, index) in fromdataadd" :key="index" :radio="item.radio"
					:minleft="item.minleft" :maxleft="item.maxleft" :options="item.options" :btx="item.btx"
					:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
					:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
					:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"
					:min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled"
					:event="item.event">
				</Commondropdownlist>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这些数据吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import headerData from '../headerData/headerData'
	import {
		InventoryClassList
	} from '@/api/home'
	import {
		GetInventoryClassNTSQuotaInfo,
		AddInventoryClassNTSQuota,
		EditInventoryClassNTSQuota,
		DeleteInventoryClassNTSQuota,
		DownloadInventoryClassNTSQuotaTemplet,
		ImportInventoryClassNTSQuota
	} from '@/api/newsapi'

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				selectData: [],
				dialogVisibles: false,
				dialogVisibledel: false,
				dialogVisiblesdrjg: false,
				tableDatadrjg: [],
				title: '',
				fromdataadd: [],
				headerData: [],
				from: {
					ID: "",
					InvClass: "",
					YearQuota: 0,
					JanQuota: 0,
					FebQuota: 0,
					MarQuota: 0,
					AprQuota: 0,
					MayQuota: 0,
					JunQuota: 0,
					JulQuota: 0,
					AugQuota: 0,
					SepQuota: 0,
					OctQuota: 0,
					NovQuota: 0,
					DecQuota: 0
				},
				qx: {
					add: false,
					update: false,
					del: false
				}
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.getInvClassOptions()
			this.QX();
		},
		methods: {
			getSingleSelectedRow(actionName) {
				if (this.selectData.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}！`)
					return null
				}
				return this.selectData[0]
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1089) {
								this.qus = items.Nodes;
							}
						});
					}
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "browse") {
							this.qx.browse = true;
						}
					});
				}
			},
			async getInvClassOptions() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.fromdataadd[0].options = data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}))
				}
			},
			async adduser() {
				this.from = {
					ID: "",
					InvClass: "",
					YearQuota: 0,
					JanQuota: 0,
					FebQuota: 0,
					MarQuota: 0,
					AprQuota: 0,
					MayQuota: 0,
					JunQuota: 0,
					JulQuota: 0,
					AugQuota: 0,
					SepQuota: 0,
					OctQuota: 0,
					NovQuota: 0,
					DecQuota: 0
				}
				this.dialogVisibles = true
				this.$nextTick(() => {
					this.$refs.proadd.forEach(item => item.modelvalue = '')
				})
			},
			async update() {
				const row = this.getSingleSelectedRow('修改')
				if (!row) return
				this.from.ID = row.ID
				let {
					code,
					data
				} = await GetInventoryClassNTSQuotaInfo({
					ID: this.from.ID
				})
				if (code == 0) {
					this.from = data
					this.dialogVisibles = true
					this.$nextTick(() => {
						this.$refs.proadd[0].modelvalue = data.InvClass
						this.$refs.proadd[1].modelvalue = data.YearQuota
						this.$refs.proadd[2].modelvalue = data.JanQuota
						this.$refs.proadd[3].modelvalue = data.FebQuota
						this.$refs.proadd[4].modelvalue = data.MarQuota
						this.$refs.proadd[5].modelvalue = data.AprQuota
						this.$refs.proadd[6].modelvalue = data.MayQuota
						this.$refs.proadd[7].modelvalue = data.JunQuota
						this.$refs.proadd[8].modelvalue = data.JulQuota
						this.$refs.proadd[9].modelvalue = data.AugQuota
						this.$refs.proadd[10].modelvalue = data.SepQuota
						this.$refs.proadd[11].modelvalue = data.OctQuota
						this.$refs.proadd[12].modelvalue = data.NovQuota
						this.$refs.proadd[13].modelvalue = data.DecQuota
					})
				}
			},
			async dialogOK() {
				const params = {
					ID: this.from.ID,
					InvClass: this.$refs.proadd[0].modelvalue,
					YearQuota: this.$refs.proadd[1].modelvalue,
					JanQuota: this.$refs.proadd[2].modelvalue,
					FebQuota: this.$refs.proadd[3].modelvalue,
					MarQuota: this.$refs.proadd[4].modelvalue,
					AprQuota: this.$refs.proadd[5].modelvalue,
					MayQuota: this.$refs.proadd[6].modelvalue,
					JunQuota: this.$refs.proadd[7].modelvalue,
					JulQuota: this.$refs.proadd[8].modelvalue,
					AugQuota: this.$refs.proadd[9].modelvalue,
					SepQuota: this.$refs.proadd[10].modelvalue,
					OctQuota: this.$refs.proadd[11].modelvalue,
					NovQuota: this.$refs.proadd[12].modelvalue,
					DecQuota: this.$refs.proadd[13].modelvalue
				}
				let res = this.from.ID ? await EditInventoryClassNTSQuota(params) : await AddInventoryClassNTSQuota(
					params)
				if (res.code == 0) {
					this.$message.success(this.from.ID ? '修改成功' : '新增成功')
					this.dialogVisibles = false
					this.$parent.getList()
				} else {
					this.$message.error(res.message)
				}
			},
			cancel() {
				this.dialogVisibles = false
			},
			del() {
				const row = this.getSingleSelectedRow('删除')
				if (!row) return
				this.from.ID = row.ID
				this.dialogVisibledel = true
			},
			async dialogOKdel() {
				let {
					code,
					message
				} = await DeleteInventoryClassNTSQuota({
					IDs: [this.from.ID]
				})
				if (code == 0) {
					this.$message.success('删除成功')
					this.dialogVisibledel = false
					this.$parent.getList()
				} else {
					this.$message.error(message)
				}
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			async proExport() {
				this.$emit('export')
			},
			async Productexport(file) {
				if (file) {
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportInventoryClassNTSQuota(formData)
					if (res.code == 0) {
						this.$message.success(res.message)
						this.$parent.getList()
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message.error(res.message)
					}
				}
			},
			async proDowload() {
				let {
					data,
					code,
					message
				} = await DownloadInventoryClassNTSQuotaTemplet({})
				if (code == 0) {
					window.location.href = data
				} else {
					this.$message.error(message)
				}
			},
			onRowClick(val) {
				this.from.ID = val.ID
			},
			handleSelectionChange(e) {
				this.selectData = e
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;
		padding: 10px;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
		}

		.Dowload {
			margin-left: 15px;
			color: #409EFF;
			cursor: pointer;
			font-size: 14px;
		}
	}

	.from-grid {
		display: grid !important;
		grid-template-columns: 1fr 1fr !important;
		gap: 10px;
		padding: 20px;
		width: 100%;
		box-sizing: border-box;

		&>* {
			display: block !important;
			width: 100% !important;
			margin-left: 0 !important;
		}
	}
</style>
